export const SET_TENDIKS = (state, payload) => {
    state.tendiksData = payload;
}

export const SET_TENDIKS_PERSEKOLAH = (state, payload) => {
    state.tendiksPersekolahData = payload;
}

export const SET_TENDIKS_QUEUE_PERSEKOLAH = (state, payload) => {
    state.tendiksQueuePersekolahData = payload;
}

export const SET_TENKELS_PERSEKOLAH = (state, payload) => {
    state.tenkelsPersekolahData = payload;
}

export const SET_SEMUA_TENKELS = (state, payload) => {
    state.semuaTenkels = payload;
}

export const SET_MUTENS_PERSEKOLAH = (state, payload) => {
    state.mutensPersekolahData = payload;
}

export const SET_SEMUA_MUTENS = (state, payload) => {
    state.semuaMutens = payload;
}
